var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',[(_vm.modal)?_c(_vm.modal,{tag:"component",on:{"close":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }